import styled from "styled-components";

export const Banner = styled.div`
    width: 100%;
    height: 320px;
    background: #4da6ff; 

    display: flex;
    align-items: center;
    justify-content: space-around;

    @media (max-width: 768px) {
        height: auto;
        padding: 10px 0;
    }
    @media (min-width: 769px) and (max-width: 1024px) {
        padding: 0;
    }
`
export const BannerText = styled.div`
    color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    @media (max-width: 768px) {
        text-align: center;
        align-items: center;
        width: 100%;
        padding: 0;
    }

    p {
        font-size: 1rem;
        margin: 0.5rem 0 1rem;

        a {
            text-decoration: none;
            color: white;

            &:hover {
                text-decoration: underline;
            }
        }

        @media (max-width: 768px) {
            font-size: 0.8rem;
            margin-left: 0px;
        }
    }

    h2 {
        margin: 1rem 0 !important;
        font-size: 4rem;

        @media (max-width: 768px) {
            font-size: 1.5rem;
            text-align: center;
        }
        @media (min-width: 769px) and (max-width: 1024px){
            font-size: 2.5rem;
        }
    }
`;

export const BannerLogo = styled.div`
    img {
        max-width: 400px;
        height: auto;
        
        @media (max-width: 768px) {
            max-width: 150px;
            margin-top: 20px;
            display: none;
        }
        @media (min-width: 769px) and (max-width: 1024px){
            max-width: 280px;
            margin-top: 20px;
        }
    }
`;
